import Select from 'react-select';
import { RDateRangePicker } from '../ReactComponents/RDateRangePicker';
import RagnaLoader from '../ReactComponents/RagnaLoader';
import { useState, useEffect } from 'react';
import moment from 'moment';
import RagnaModal from '../ReactComponents/RagnaModal';
import { useForm, Controller } from 'react-hook-form';
import axios from 'axios';
import { ajax_api } from '../../Globals';
import { PDFViewer, Document, pdf } from '@react-pdf/renderer';
import MyDocument from '../ReactComponents/GeneratePDF';
import { Helmet } from 'react-helmet';

const Reports = props => {
    const { register, handleSubmit, reset, control, getValues, watch } = useForm();

    const [dateRange, setDateRange] = useState("-,-");
    const [reportType, setReportType] = useState("");
    const reportTypes = [
        { label: "All Parameters", value: "" },
        { label: "Main Author", value: "author" },
        { label: "Committee", value: "committee" },
        { label: "Title", value: "title" },
        { label: "Classification / Category", value: "class" },
        { label: "Council", value: "council" },
        { label: "List All Items", value: "all" },
    ];

    const getDates = dates => {
        var d = {};
        if (dates) {
            var ds = dates.split(",");
            if (moment(ds[0]).isValid())
                d = { start: moment(ds[0]) }
            if (moment(ds[1]).isValid())
                d = { ...d, end: moment(ds[1]) }
        }
        console.log(d);
        return d;
    }
    const [modalOpen, setModalOpen] = useState(false);
    const [reportData, setReportData] = useState();
    const [reportError, setReportError] = useState();

    const [reportPdf, setReportPdf] = useState();

    useEffect(_ => {
        setReportPdf();
        if (reportData) {
            setReportPdf(setDocument());
        }
    }, [reportData]);

    const reportModal = <RagnaModal
        width={reportPdf != null ? "80%" : null}
        boxStyle={reportPdf == null ? { minHeight: 0 } : null}
        noBackdropClose={true}
        noBtn={true}
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        body={<>
            {
                reportError ? <div className="alert alert-danger">{reportError}</div> :
                    (
                        reportData == null ? <RagnaLoader text="Generating PDF" /> : <>
                            <div className="d-flex">
                                <div style={{ flex: 1, fontSize: 22 }}>
                                    Result count: <u>{reportData.length}</u>
                                </div>
                            </div>
                            <hr />
                            <div>
                                {
                                    reportPdf != null ? <PDFViewer style={{ width: "100%", height: "70vh" }} >
                                        {reportPdf}
                                    </PDFViewer> :
                                        <>
                                            <i className="fa fa-spinner fa-pulse" /> Generating pdf...
                                        </>
                                }
                            </div>

                        </>
                    )
            }
        </>
        }
    />



    const resetFields = _ => {
        setDateRange("");
        setOrderBy("EnactedDate");
        setItemType();
        setReportType("");
        setIsAscending(true);
        reset();
    }

    useEffect(_ => {
        if (modalOpen === false) setReportData();
    }, [modalOpen]);

    const isInputShown = (name, selected) => selected === name || selected === ""

    const defaultOption = n => ({ label: "All " + n, value: null });

    const [itemTypes, setItemTypes] = useState([defaultOption("Item Types")]);
    const [codeAuthor, setCodeAuthor] = useState([]);
    const [codeCouncil, setCodeCouncil] = useState([]);
    const [codeCategory, setCodeCategory] = useState([]);
    const [codeCommittee, setCodeCommittee] = useState([]);

    const [itemType, setItemType] = useState();

    useEffect(_ => {
        axios.get(ajax_api + "items/getOptions")
            .then(response => {
                return response.data
            })
            .then(d => {
                setItemTypes([defaultOption("Item Types"), ...d.itemTypes])
                setCodeCouncil(d.councils)
                setCodeAuthor(d.officials)
                setCodeCategory(d.categories)
                setCodeCommittee(d.committees)
            })
            .catch(error => {
                console.log(error.response.data.error)
            })
    }, [])

    const [orderBy, setOrderBy] = useState("EnactedDate");
    const dbColumns = [
        { value: "EnactedDate", label: "Enacted Date" },
        { value: "Session", label: "Session" },
        { value: "Id", label: "ID" },
    ]

    const [isAscending, setIsAscending] = useState(true);


    const onSubmit = d => {
        setReportError();

        var cols = [
            "SoleAuthor",
            "CouncilId",
            "Committees",
            "Categories",
            "Title"
        ];
        var multiFilter = {};

        //report type filtering
        switch (reportType) {
            case "author":
                cols = ["SoleAuthor"];
                break;
            case "council":
                cols = ["CouncilId"];
                break;
            case "committee":
                cols = ["Committees"];
                break;
            case "class":
                cols = ["Categories"];
                break;
            case "title":
                cols = ["Title"];
                break;
        }

        //from form
        if (reportType !== "all") cols.forEach(c => multiFilter = { ...multiFilter, [c]: d[c] });

        if (itemType !== "" && itemType !== null) multiFilter = { ...multiFilter, ItemType: itemType };
        if (dateRange !== "") multiFilter = { ...multiFilter, EnactedDate: dateRange };

        axios.get(`${ajax_api}getReport/items`, {
            withCredentials: true,
            responseType: 'blob',
            params: {
                multi_filter: JSON.stringify(multiFilter),
                isAsc: isAscending,
                order_col: orderBy,
                entry_size: -1
            }
        }).then(e => {
            var w = window.open(URL.createObjectURL(e.data), '_blank', 'location=yes,scrollbars=yes,status=yes');
            //var newWin = window.open(URL.createObjectURL(e.data), 'LTS Resolutions Report');
            //if (!newWin || newWin.closed || typeof newWin.closed == 'undefined') {
            //POPUP BLOCKED
            //   alert("Please enable popups to show report!")
            //}
        })
            .catch(_ => alert("Connection Timed out. Please try again later."))
            .finally(_ => setModalOpen(false));
    }


    const setDocument = _ =>
        <MyDocument
            header="RESOLUTIONS AND ORDINANCES ENACTED BY THE MEMBERS OF THE SANGGUNIANG PANLUNGSOD OF PUERTO PRINCESA"
            subheader={getDates(dateRange).start != null ?
                (getDates(dateRange).end != null ?
                    `As of ${getDates(dateRange).start.format("MMMM DD, YYYY")} To ${getDates(dateRange).end.format("MMMM DD, YYYY")}` :
                    `Starting ${getDates(dateRange).start.format("MMMM DD, YYYY")}`) :
                (getDates(dateRange).end != null ? `Until ${getDates(dateRange).end.format("MMMM DD, YYYY")}` : "")
            }
            columns={[
                {
                    label: "Resolution",
                    value: r =>
                        (
                            r.ItemType === "Resolution" ? "R-" :
                                (r.ItemType === "Appropriation Ordinance" ? "AO-" :
                                    (r.ItemType === "Ordinance" ? "O-" : "")
                                )
                        ) + r.ItemCode
                },
                {
                    label: "Date Enacted",
                    value: r => moment(r.EnactedDate).format("MMMM DD, YYYY")
                },
                {
                    label: "Title",
                    value: r => r.Title
                },
                {
                    label: "Author/s",
                    value: r => (r.Author.trim() === "," || r.Author?.trim() === "." || r.Author?.trim() === "") ?
                        r.Committee ?? "-no author-" : "Hon. " + r.Author + (r.CoAuthor.length > 0 ?
                            ", " + r.CoAuthor.map(o => "Hon. " + o.trim()).join(", ") : "")
                }

            ]}
            data={reportData} />

    return <div className="container bg-white py-3">
        <Helmet>
            <title>LTS | Reports</title>
        </Helmet>
        {reportModal}
        <div className="row">
            <div className="col-md-6">
                {
                    /*<div className="mb-3">
                        Filter Items by: <Select value={reportTypes.filter(r => r.value == reportType)}
                            options={reportTypes}
                            onChange={v => setReportType(v.value)} />
                    </div>
                    */
                }
                <div className="mb-3">
                    Item Type: <Select value={itemTypes.filter(r => r.value == itemType)}
                        options={itemTypes}
                        onChange={v => setItemType(v.value)} />
                </div>
                Filter by enacted date:
                <RDateRangePicker absolute={true} limitYear={moment().format("YYYY")} yearRange={80} selectedDates={dateRange} onChange={setDateRange} />
                <div className="text-danger text-right">* Leave blank to ignore date filtering</div>
                Sort by:
                <Select options={dbColumns}
                    value={dbColumns.filter(c => c.value == orderBy)}
                    onChange={v => setOrderBy(v.value)} />
                <div className="form-check mt-1 ms-2">
                    <input onChange={_ => setIsAscending(a => !a)} checked={isAscending}
                        className="form-check-input" type="checkbox" id="isAsc" />
                    <label className="form-check-label" htmlFor="isAsc">
                        Ascending
                    </label>
                </div>

            </div>
            <div className="col" style={{ borderLeft: "1px solid #ccc" }}>
                <form onSubmit={handleSubmit(onSubmit)}>

                    {
                        isInputShown("council", reportType) ? <>
                            Council:
                            <Controller
                                name="CouncilId"
                                control={control}
                                //rules={}
                                render={({ field: { onChange, value } }) => {
                                    return (
                                        <Select
                                            isClearable={true}
                                            placeholder="Match All"
                                            onChange={e => e && e.value ? onChange(e.value) : onChange("")}
                                            value={codeCouncil.filter(a => a.value === value)}
                                            options={codeCouncil} />
                                    )
                                }
                                }
                            />
                        </> : ""
                    }
                    {
                        isInputShown("author", reportType) ? <>
                            Main Author:
                            <Controller
                                name="SoleAuthor"
                                control={control}
                                //rules={}
                                render={({ field: { onChange, value } }) => {
                                    return (
                                        <Select
                                            isClearable={true}
                                            placeholder="Match All"
                                            onChange={e => e && e.value ? onChange(e.value) : onChange("")}
                                            value={codeAuthor.filter(a => a.value === value)}
                                            options={watch("CouncilId") ? codeAuthor.filter(c => c.councilIds.includes(getValues().CouncilId)) : codeAuthor} />
                                    )
                                }
                                }
                            />
                        </> : ""
                    }
                    {
                        isInputShown("committee", reportType) ? <>
                            Committee:
                            <Controller
                                name="Committees"
                                control={control}
                                //rules={}
                                render={({ field: { onChange, value } }) => {
                                    return (
                                        <Select
                                            isClearable={true}
                                            placeholder="Match All"
                                            onChange={e => e && e.value ? onChange(e.value) : onChange("")}
                                            value={codeCommittee.filter(a => a.value === value)}
                                            options={codeCommittee} />
                                    )
                                }
                                }
                            />
                        </> : ""
                    }
                    {
                        isInputShown("title", reportType) ? <>
                            Title:
                            <input className="form-control mb-2" {...register("Title")} />
                        </> : ""
                    }
                    {
                        isInputShown("class", reportType) ? <>
                            Classification / Category:
                            <Controller
                                name="Categories"
                                control={control}
                                //rules={}
                                render={({ field: { onChange, value } }) => {
                                    return (
                                        <Select
                                            isClearable={true}
                                            placeholder="Match All"
                                            onChange={e => e && e.value ? onChange(e.value) : onChange("")}
                                            value={codeCategory.filter(a => a.value === value)}
                                            options={codeCategory} />
                                    )
                                }
                                }
                            />
                        </> : ""
                    }
                </form>
            </div>
        </div>
        <hr />
        <div className="row">
            <div className="col d-flex justify-content-end">
                <button className="ro-button me-2" onClick={resetFields}>
                    <span>Reset Fields</span>
                </button>
                <button className="ro-button" onClick={_ => {
                    handleSubmit(onSubmit)();
                    setModalOpen(true);
                }}>
                    <span>Generate Report</span>
                </button>
            </div>
        </div>
    </div>
}

export default Reports;